import styled from 'styled-components'
import Select from 'react-select'
import { Creatable } from 'react-select'
import { v1 as color, media, contentLevels } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

export const Wrap = styled.div`
  width: 100%;
  position: relative;
`

export const Icon = styled(BaseIcon)`
  font-size: 1.5rem;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  text-align: center;
  height: 100%;
  color: #0e60c9;

  ${p => (p.before ? `left: 0.9375rem;` : `right: 0.9375rem;`)}
`

export const ReactSelect = styled(Select)`
  line-height: 3;
  font-size: 1.375rem;
  color: ${color.MORTAR};
  background-color: transparent;
  width: 100%;
  transition: all 0.2s;
  position: relative;
  border-radius: 0;
  appearance: none;

  & .Select > .Select-value {
    border: 1px solid ${p => p.theme.borderColor};
    padding-left: 0.9375rem;
  }

  .Select-control {
    cursor: pointer;
  }

  ${p =>
    p.readOnly &&
    `
    .Select.has-value.Select--single.Select.is-disabled
    > .Select-control
    .Select-value
    .Select-value-label ,
  .Select.has-value.is-pseudo-focused.Select--single.Select.is-disabled
    > .Select-control
    .Select-value
    .Select-value-label {
    color: ${color.GREY} !important;
    }
  `}

  // this is the style for the containing element of 
  // dropdown items. We adjust the z-index here to make
  // sure that the options show over any other component
  // or label.
  .Select-menu-outer {
    // dropdown type list components are given a z-index that is
    // just above next major content level because in most cases
    // dropdown list options should be above pretty much everything
    // else that could block them. InputSelects are at +1 and
    // labels are +2.  and icons are + 3, This is why we do a +4 here.
    z-index: ${contentLevels.components + 4};

    ${p =>
      !p.dropDown &&
      `
      top: auto;
      bottom: 100%;
    `}
  }

  .Select-option {
    line-height: 1.5;
  }

  .Select-option.is-selected {
    background-color: transparent;
    color: ${color.MORTAR};
  }

  // In IE11, the default position here is causing the arrow icon
  // to render too high, and too small for some reason. Changing
  // the position to static seems to fix the issue w/o affecting
  // other browsers. In chrome, the white background is causing the
  // border to be blocked out. I think the white bg is to block
  // the selected value from displaying under the arrow, but that
  // doesn't seem to be happening anyway, so I'm just removing the
  // background so that a complete border shows (lesser of 2 evils).
  .Select-arrow-zone {
    position: static;
    background: none;
  }

  ${Icon} ~ & {
    padding-left: 3.125rem;
  }

  &::placeholder {
    color: ${p => (p.label ? 'transparent' : p.theme.borderColor)};
    transition: color 0.2s;
    transition-delay: 0.2s;
  }

  &.visited {
    &::placeholder {
      color: ${color.SILVER};
    }
  }

  &:focus {
    padding-left: 1.25rem;
    border: 2px solid #0e60c9;
  }

  ${Icon} ~ &:focus {
    padding-left: 3.125rem;
  }

  ${p =>
    p.slim &&
    `
    height: 3.125rem;
    line-height: 3.125rem;
    color: ${color.MORTAR};
    font-size: 1.125rem;
  `}

  ${media.belowDesktop`
    height: 3.125rem;
    line-height: 3.125rem;
  `}

  ${p =>
    !p.optionRenderer &&
    !p.group &&
    `
    .Select-option {
      padding-top: 0.625rem;
      padding-bottom: 0.625rem;
    }
  `}

  ${p =>
    (!p.optionRenderer || p.hoverEffects) &&
    `
    &.Select--single >  .Select-control .Select-value {
      padding-left: 1.25rem;
    }

    .Select-option {
      margin-left: 1.25rem;
      padding-left: 0;
      border-bottom: 1px solid ${color.SILVER};
      background-color: transparent;
    }
    .Select-option.is-focused {
      border-bottom: 1px solid ${color.SILVER};
      background-color: transparent;
      margin-left: 1.25rem;
      padding-left: 0;
    }
    .Select-option:hover {
      background-color: #F1F5F9;
      animation-name: list-overlay-fill;
      animation-duration: 200ms;
      animation-fill-mode: forwards;
    }
    .Select-option.is-disabled {
      cursor: default;
      border-bottom: none;
    }
    .Select-option.is-disabled:hover {
      background-color: transparent;
      animation-name: none;
    }

    .Select-option:last-child {
      border-bottom: none;
    }

    @keyframes list-overlay-fill {
      0%   {
        margin-left: 1.25rem;
        padding-left: 0rem;
      }
      100% {
        margin-left: 0rem;
        padding-left: 1.25rem;
      }
    }
    
    .Select-option:hover.is-selected {
      background-color: #F1F5F9;
      animation-name: list-overlay-fill;
      animation-duration: 200ms;
      animation-fill-mode: forwards;
    }
    
  `}
`

export const ReactCreatable = styled(Creatable)`
  min-height: 3.75rem;
  line-height: 1.5;
  font-size: 1.375rem;
  color: ${color.MORTAR};
  background-color: transparent;
  width: 100%;
  transition: all 0.2s;
  position: relative;
  border-radius: 0;
  appearance: none;

  & .Select > .Select-value {
    border: 1px solid ${p => p.theme.borderColor};
    padding-left: 0.9375rem;
  }

  .Select-control {
    height: 3.75rem;
  }

  .Select-option {
    line-height: 1.5;
  }

  .Select-option.is-selected {
    background-color: transparent;
    color: ${color.MORTAR};
  }

  .Select-menu-outer {
    // dropdown type list components are given a z-index that is
    // just above next major content level because in most cases
    // dropdown list options should be above pretty much everything
    // else that could block them. InputSelects are at +1 and
    // labels are +2.  and icons are + 3, This is why we do a +4 here.
    z-index: ${contentLevels.components + 4};

    ${p =>
      !p.dropDown &&
      `
      top: auto;
      bottom: 100%;
    `}
  }

  ${Icon} ~ & {
    padding-left: 3.125rem;
  }

  &::placeholder {
    color: ${p => (p.label ? 'transparent' : p.theme.borderColor)};
    transition: color 0.2s;
    transition-delay: 0.2s;
  }

  &.visited {
    &::placeholder {
      color: ${color.SILVER};
    }
  }

  &:focus {
    padding-left: 1.25rem;
    border: 2px solid #0e60c9;
  }

  ${Icon} ~ &:focus {
    padding-left: 3.125rem;
  }

  ${p =>
    p.slim &&
    `
    height: 3.125rem;
    line-height: 3.125rem;
    color: ${color.MORTAR};
    font-size: 1.125rem;
  `}

  ${media.belowDesktop`
    height: 3.125rem;
    line-height: 3.125rem;
  `}

  // To avoid clashes with styled search options

  ${media.belowDesktop`
    padding-left: 0.625rem;
  `}

  ${p =>
    !p.optionRenderer &&
    !p.group &&
    `
    .Select-option {
      padding-top: 0.625rem;
      padding-bottom: 0.625rem;
    }
  `}

  ${p =>
    (!p.optionRenderer || p.hoverEffects) &&
    `
    &.Select--single >  .Select-control .Select-value {
      padding-left: 1.25rem;
    }

    .Select-option {
      margin-left: 1.25rem;
      padding-left: 0;
      border-bottom: 1px solid ${color.SILVER};
      background-color: transparent;
    }
    .Select-option.is-focused {
      border-bottom: 1px solid ${color.SILVER};
      background-color: transparent;
      margin-left: 1.25rem;
      padding-left: 0;
    }
    .Select-option:hover {
      background-color: #F1F5F9;
      animation-name: list-overlay-fill;
      animation-duration: 200ms;
      animation-fill-mode: forwards;
    }
    .Select-option.is-disabled {
      cursor: default;
      border-bottom: none;
    }
    .Select-option.is-disabled:hover {
      background-color: transparent;
      animation-name: none;
    }

    .Select-option:last-child {
      border-bottom: none;
    }

    @keyframes list-overlay-fill {
      0%   {
        margin-left: 1.25rem;
        padding-left: 0rem;
      }
      100% {
        margin-left: 0rem;
        padding-left: 1.25rem;
      }
    }
    
    .Select-option:hover.is-selected {
      background-color: #F1F5F9;
      animation-name: list-overlay-fill;
      animation-duration: 200ms;
      animation-fill-mode: forwards;
    }
  `}
`

export const Label = styled.span`
  transition: all 0.2s;
  position: absolute;
  top: 0.125rem;
  left: 0.125rem;
  height: 3.125rem;
  line-height: 3.125rem;
  font-size: 1.375rem;
  color: ${p => (p.fieldDisabled ? color.SILVER : '#0E60C9')};
  background-color: white;
  left: 0.9375rem;
  padding: 0 0.3125rem;
  opacity: 0;
  // we are using +2 because the select is at +1
  // and the label should be displaying above that.
  z-index: ${contentLevels.components + 2};

  &:focus {
    padding-left: 1.25rem;
    border: 2px solid #0e60c9;
  }

  ${p =>
    !p.visited &&
    `
      width: 0; // It is important to have the width 0 so that it doesnt overlap the dropdown arrows
  `}
  ${p =>
    p.visited &&
    `
    top: -0.625rem;
    height: 1.375rem;
    line-height: 1.375rem;
    left: 0.9375rem;
    padding: 0 0.3125rem;
    font-size: 1.0625rem;
    opacity: 1;
    color: ${p => p.theme.labelColor};
  `}
`
